import axios from '../../v2/app/services/axiosService';
import DOMPurify from 'dompurify'; // MLD-4779

export default {
  async createFolder(formData) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    const response = await axios.post(`/api/folders`, formData, config);
    return response.data;
  },
  editFolder(folder, formData) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    return axios.post(`/api/folders/${folder.id}`, formData, config)
  },
  async deleteFolderImage(folderID) {
    const response = await axios.delete(`/api/folders/${folderID}/image`);
    return response.data;
  },
  deleteFolder(folder) {
    return axios.delete(`/api/folders/${folder.id}`);
  },
  async addPresentations(folder, presentationIDs) {
    const form = {
      presentation_ids: presentationIDs,
    };
    return axios.post(`/api/folders/${folder.id}/presentations`, form);
  },
  async removePresentation(folder, presentation) {
    return axios.delete(`/api/folders/${folder.id}/presentations/${presentation.id}`);
  },
  async getFolder(folderID) {
    const {data} = await axios.get(`/api/folders/${folderID}`);
    return data;
  },
  async getFolders() {
    const response = await axios.get(`/api/folders`);
    return response.data.filter(folder => !folder.parent_id);
  },
  folderDepth(folder, withIcon = false, char = '&nbsp;', ancestorPath = false) {
    if (folder.depth === 0) {
      return withIcon ? `<i class="fa fa-fw fa-btn fa-folder-open"></i>${DOMPurify.sanitize(folder.name)}` : DOMPurify.sanitize(folder.name);
    }
    if (withIcon) {
      if (ancestorPath) {
        const ancestors = folder.ancestors.map(a => DOMPurify.sanitize(a.name)).join(' / ');
        if (ancestors) {
          return `<i class="fa fa-fw fa-btn fa-folder-o"></i>${ancestors} / ${DOMPurify.sanitize(folder.name)}`;
        }
        return `<i class="fa fa-fw fa-btn fa-folder-o"></i>${DOMPurify.sanitize(folder.name)}`;
      }
      char = `<i class="fa fa-fw"></i>`; // MLD-1893
      return char.repeat(folder.depth * 1) + `<i class="fa fa-fw fa-btn fa-folder-o"></i>${DOMPurify.sanitize(folder.name)}`;
    }
    if (ancestorPath) {
      return folder.ancestor_path;
    }
    return char.repeat(folder.depth * 2) + ' ' + DOMPurify.sanitize(folder.name);
  },
  open(vm, folderID) {
    if (folderID) {
      vm.$router.push({name: 'folder.show', params: {folderID: folderID}});
    } else {
      vm.$router.push({name: 'folders'});
    }
  },
  move(folder, newIndex) {
    return axios.put(`/api/folders/${folder.id}/move`, {newIndex: newIndex})
  },
  async getFlatTree() {
    const response = await axios.get(`/api/folders/flat-tree`);
    return response.data;
  }
}
